import { createFileRoute } from "@tanstack/react-router";
import { PermissionGate } from "@/shared/auth/PermissionGate";
import { tienePermisoEnSesion } from "@/shared/auth/permiso-en-sesion";
import { PERMISOS } from "@/lib/permisos";
import { ErrorAlert } from "@/components/ui";
import { AdminConfiguracionesPage } from "@/features/admin-configuraciones/components/AdminConfiguracionesPage";
import { configuracionesAdminQueryOptions } from "@/features/admin-configuraciones/hooks/use-configuraciones-admin";

/**
 * Ruta `/admin/configuraciones` · gestor de ajustes de la app (tabla
 * administracion.configuraciones).
 */
export const Route = createFileRoute("/_authed-tw/admin/configuraciones")({
  loader: ({ context: { queryClient } }) =>
    tienePermisoEnSesion([PERMISOS.adminConfiguraciones])
      ? queryClient.ensureQueryData(configuracionesAdminQueryOptions)
      : undefined,
  component: () => (
    <PermissionGate permisos={[PERMISOS.adminConfiguraciones]}>
      <AdminConfiguracionesPage />
    </PermissionGate>
  ),
  errorComponent: ({ error }) => <ErrorAlert error={error} />,
});
